import { FC } from 'react';

export const FontStyleIcon: FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <path d="M4 20l4-12 4 12" />
    <path d="M6 16h4" />

    <path d="M14 20l2.5-7 2.5 7" />
    <path d="M15.5 17h2" />
  </svg>
);
